"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bastia-umbra": {
    "57625213": [{
      "hkey": "212ef20b",
      "slug": "cipresso-san-lorenzo-santa-lucia-xxv-aprile",
      "name": "Cipresso-San Lorenzo-Santa Lucia-XXV Aprile",
      "primary": true,
      "skipSearch": false
    }],
    "cipresso": [{
      "hkey": "212ef20b",
      "slug": "cipresso-san-lorenzo-santa-lucia-xxv-aprile",
      "name": "Cipresso-San Lorenzo-Santa Lucia-XXV Aprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8b64cbee": [{
      "hkey": "212ef20b",
      "slug": "cipresso-san-lorenzo-santa-lucia-xxv-aprile",
      "name": "Cipresso-San Lorenzo-Santa Lucia-XXV Aprile",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "212ef20b",
      "slug": "cipresso-san-lorenzo-santa-lucia-xxv-aprile",
      "name": "Cipresso-San Lorenzo-Santa Lucia-XXV Aprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bastia-umbra"
    }]
  }
};
exports["default"] = _default;